<app-sidebar-nav-items [items]="navItemsArray"> </app-sidebar-nav-items>
